/* src/app/page404/under-construction/under-construction.component.scss */
.work-in-progress-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: white;
}
.custom-card {
  width: 475px;
  height: 175px;
  padding: 24px;
  background: #fff;
  border-radius: 10px;
  border: 2px solid #D0D5DD;
  border-style: dashed;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.custom-card .card-title {
  font-size: 18px;
  font-weight: 600;
  color: #D47500;
  text-align: center;
  margin: 0;
}
.custom-card .card-subtitle {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #363F72;
  text-align: center;
}
.custom-card .card-footer {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
}
.custom-card .card-footer .logout-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}
.custom-card .card-footer .logout-button:hover {
  background-color: #c82333;
}
.icon-circle-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}
.outer-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFF1E0;
}
.inner-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #FFE8CC;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-inside {
  font-size: 18px;
  color: #D47500;
}
/*# sourceMappingURL=under-construction.component-436CD7CL.css.map */
